export default __webpack_public_path__ + "static/media/icon_pst_tier_silver.c89ecc34.svg";